// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_orthohouse_visit = /** @type {(inputs: {}) => string} */ () => {
	return `Visit OrthoHouse`
};

const el_orthohouse_visit = /** @type {(inputs: {}) => string} */ () => {
	return `Μετάβαση στην OrthoHouse`
};

const ru_orthohouse_visit = /** @type {(inputs: {}) => string} */ () => {
	return `Перейти на сайт OrthoHouse`
};

const he_orthohouse_visit = /** @type {(inputs: {}) => string} */ () => {
	return `לאתר OrthoHouse`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const orthohouse_visit = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.orthohouse_visit(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("orthohouse_visit", locale)
	if (locale === "en") return en_orthohouse_visit(inputs)
	if (locale === "el") return el_orthohouse_visit(inputs)
	if (locale === "ru") return ru_orthohouse_visit(inputs)
	if (locale === "he") return he_orthohouse_visit(inputs)
	return "orthohouse_visit"
};